export function pushSession(session) {
  if (process.env.REACT_APP_CLIENT_APP === 'true') {
    window.ProkatPush?.postMessage(JSON.stringify({ action: 'session', session: session || '' }));
  }
}

export function pushAction(action) {
  window.ProkatPush?.postMessage(JSON.stringify({ action }));
}
